import { createFileRoute, redirect } from '@tanstack/react-router';

// `/settings/billing` redirects to the Your Plan tab, the default billing landing page.
export const Route = createFileRoute('/_authenticated/settings/billing/')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/billing/your-plan' });
  },
});
